import { withClass } from "~/common/hoc/withClass";
import { TableBody, TableCell, TableRow } from "~/common/components/Table/TableElements";

export const TCell = withClass("scha__orders__overview-table__cell")(TableCell);
export const TBody = withClass("scha__orders__overview-table__body")(TableBody);
export const TUpperRow = withClass("scha__orders__overview-table__upper-row")(TableRow);
export const TUpperCell = withClass("scha__orders__overview-table__cell scha__orders__overview-table__upper-cell")(
  TableCell,
);
